module.exports = __webpack_public_path__ + "static/media/206-gallery13.8396d89d.jpg";